export const COUNTRIES = [
  'Nederland',
  'België',
  'Duitsland',
  'Zwitserland',
  'Portugal',
];
